// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteStepperItem } from '@esri/calcite-components-react';

type CalciteStepperItemWrapperProps = React.ComponentProps<
  typeof CalciteStepperItem
>;

const CalciteStepperItemWrapper = ({
  complete,
  disabled,
  selected,
  ...rest
}: CalciteStepperItemWrapperProps) => {
  return (
    <CalciteStepperItem
      complete={complete || undefined}
      disabled={disabled || undefined}
      selected={selected || undefined}
      {...rest}
    />
  );
};

export default CalciteStepperItemWrapper;
